// hotelsApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { URLAPI } from "../../configuration";

export const hotelsApi = createApi({
    reducerPath: "hotelsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: URLAPI,
        prepareHeaders: (headers, { getState }) => {
            const jwt = getState().auth.user?.jwt;

            if (jwt) headers.set("Authorization", `Bearer ${jwt}`);

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getHotels: builder.query({
            query: () => "/hotels",
        }),
    }),
});

export const { useGetHotelsQuery } = hotelsApi;
export const selectHotels = hotelsApi.endpoints.getHotels.select();
